import { render, staticRenderFns } from "./BioShareModal.vue?vue&type=template&id=37bd267e&scoped=true&"
import script from "./BioShareModal.vue?vue&type=script&lang=ts&"
export * from "./BioShareModal.vue?vue&type=script&lang=ts&"
import style0 from "./BioShareModal.vue?vue&type=style&index=0&id=37bd267e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bd267e",
  null
  
)

export default component.exports